import type { Maybe } from '@adornis/base/utilTypes.js';
import { ID } from '@adornis/baseql/baseqlTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';

/** who a debitor account belongs to — `_id` is the account number */
@Entity()
export class DebitorAccountLabel extends AdornisEntity {
  static override _class = 'DebitorAccountLabel';

  @Field(() => ID)
  _id!: string;

  @Field(() => String)
  personID: Maybe<string>;

  /** "Vorname Nachname" */
  @Field(() => String)
  name: Maybe<string>;

  /** held by a virtual debitor, not a person */
  @Field(() => Boolean, { default: v => v ?? false })
  isVirtual!: boolean;
}
